const materialButtonConfiguration = Object.freeze({
  color: {
    primary: "primary",
    secondary: "secondary",
  },
  variant: {
    outlined: "outlined",
    contained: "contained",
    text: "text",
  },
});

export default materialButtonConfiguration;
